<button
  class="flat-button"
  (click)="onClick($event)"
  [disabled]="disabled"
  [ngClass]="ngClass"
  [type]="type"
>
  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'left'"
    [icon]="[fontSet, fontIcon]"
    class="mr-2"
  >
  </fa-icon>


  <span class="whitespace-no-wrap translate-y">
    @if (text) {
      {{ text }}
    } @else {
      <ng-content />
    }
  </span>


  <fa-icon
    *ngIf="fontSet && fontIcon && iconSide === 'right'"
    [icon]="[fontSet, fontIcon]"
    class="ml-2"
  >
  </fa-icon>
</button>
